/* ============================================================
   Whoopee House theme JS
   - product gallery: swipeable scroll strip synced with thumbs
   - slideshow arrows
   - buy now: add qty -> /checkout
   - qty stepper
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  var main = document.getElementById('galleryMain');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs .thumb'));
  var items = Array.prototype.slice.call(document.querySelectorAll('#galleryMain .media-item'));
  var videos = items.map(function (m) { return m.querySelector('video'); });
  var strip = document.getElementById('thumbs');
  // all items occupy the strip (slideshow = scroll, no hidden toggling)
  items.forEach(function (m) { m.removeAttribute('hidden'); });

  // PC: drag-to-scroll on the main gallery
  if (main) {
    var isDown = false, startX = 0, startLeft = 0, moved = false;
    main.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // touch uses native scrolling
      isDown = true; moved = false;
      startX = e.clientX; startLeft = main.scrollLeft;
      main.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      main.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!isDown) return;
      isDown = false;
      main.style.scrollSnapType = '';
      if (moved) {
        e.preventDefault();
        syncUI(currentIndex());
        // settle onto nearest slide
        goTo(Math.round(main.scrollLeft / Math.max(1, main.clientWidth)));
      }
    });
    main.addEventListener('click', function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
    main.style.cursor = 'grab';
  }

  function currentIndex() {
    if (!main) return 0;
    return Math.max(0, Math.min(items.length - 1, Math.round(main.scrollLeft / Math.max(1, main.clientWidth))));
  }
  function syncUI(i) {
    thumbs.forEach(function (t, k) { t.classList.toggle('active', k === i); });
    var t = thumbs[i];
    if (t && strip) {
      strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
    }
    videos.forEach(function (v, k) {
      if (!v) return;
      if (k === i) { v.play().catch(function () {}); } else { v.pause(); }
    });
  }
  function goTo(i) {
    i = Math.max(0, Math.min(items.length - 1, i));
    var target = i * main.clientWidth;
    var from = main.scrollLeft, dist = target - from;
    syncUI(i);
    if (Math.abs(dist) < 2) return;
    if (main._anim) cancelAnimationFrame(main._anim);
    var dur = 420, t0 = performance.now();
    var done = false;
    function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function step(now) {
      if (done) return;
      var pgr = Math.min(1, (now - t0) / dur);
      main.scrollLeft = from + dist * ease(pgr);
      if (pgr < 1) main._anim = requestAnimationFrame(step);
      else done = true;
    }
    main._anim = requestAnimationFrame(step);
    // safety net: if the rAF engine never advances (throttled/hidden tab), jump directly
    setTimeout(function () {
      if (!done && Math.abs(main.scrollLeft - target) > 4) { done = true; main.scrollLeft = target; syncUI(i); }
    }, 600);
  }
  if (main && items.length) {
    var raf = null, settleTimer = null;
    main.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; syncUI(currentIndex()); });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (main._anim) return; // programmatic animation handles its own settling
        goTo(Math.round(main.scrollLeft / Math.max(1, main.clientWidth)));
      }, 260);
    });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var prev = document.getElementById('galPrev');
    var next = document.getElementById('galNext');
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
  }

  // ---- variant tier selection ----
  var cards = Array.prototype.slice.call(document.querySelectorAll('.variant-card'));
  function selectedCard() { return document.querySelector('.variant-card.selected') || cards[0]; }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function applyVariant(card) {
    cards.forEach(function (c) { c.classList.toggle('selected', c === card); });
    var radio = card.querySelector('input'); if (radio) radio.checked = true;
    var vid = card.dataset.vid;
    var price = parseInt(card.dataset.price, 10);
    var compare = parseInt(card.dataset.compare, 10) || 0;
    var save = card.dataset.save;
    var now = document.getElementById('pNow');
    var was = document.getElementById('pWas');
    var saveEl = document.getElementById('pSave');
    if (now) now.textContent = fmt(price);
    if (was) was.textContent = compare > price ? fmt(compare) : '';
    if (saveEl) saveEl.textContent = 'Save ' + save + '%';
    [document.getElementById('addToCart'), document.getElementById('buyNow'),
     document.getElementById('mobileBuy'), document.getElementById('mobileBuyNow')].forEach(function (b) {
      if (b) b.dataset.variantId = vid;
    });
    var sbPrice = document.querySelector('#stickyBar .sb-price');
    if (sbPrice) sbPrice.innerHTML = fmt(price) + (compare > price ? ' <s>' + fmt(compare) + '</s>' : '');
  }
  cards.forEach(function (c) {
    c.addEventListener('click', function () { applyVariant(c); });
  });
  var more = document.getElementById('moreOptions');
  if (more) {
    more.addEventListener('click', function () {
      var wrap = document.getElementById('variantCards');
      var open = wrap.classList.toggle('expanded');
      more.textContent = open ? 'Fewer options \u25b4' : 'More options \u25be';
    });
  }

  // ---- cart ops ----
  function selectedVid(btn) {
    var card = selectedCard();
    return card ? card.dataset.vid : (btn ? btn.dataset.variantId : null);
  }
  function flashBtn(btn, text) {
    var orig = btn.textContent;
    btn.textContent = text;
    btn.disabled = true;
    setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
  }
  // AJAX add — stay on page (Add to cart buttons)
  function addStay(btn) {
    var vid = selectedVid(btn);
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || 'Could not add to cart'); btn.disabled = false; return; }
      flashBtn(btn, '✓ Added to cart!');
    }).catch(function () { alert('Could not add to cart'); btn.disabled = false; });
  }
  // Buy now — replace cart with selected tier, go straight to checkout (the only redirect)
  function buyNowGo(btn) {
    var vid = selectedVid(btn);
    btn.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      });
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || 'Could not add to cart'); btn.disabled = false; return; }
      window.location.href = '/checkout';
    }).catch(function () { alert('Could not add to cart'); btn.disabled = false; });
  }
  var atc = document.getElementById('addToCart');
  if (atc) atc.addEventListener('click', function () { addStay(atc); });
  // 事件委托：Shopify pixels 在加购后会重建按钮 DOM，直绑会失聪
  document.addEventListener('click', function (e) {
    var atc = e.target.closest ? e.target.closest('#addToCart') : null;
    var buy = e.target.closest ? e.target.closest('#buyNow') : null;
    var mbuy = e.target.closest ? e.target.closest('#mobileBuy') : null;
    var mbuyNow = e.target.closest ? e.target.closest('#mobileBuyNow') : null;
    if (atc) return addStay(atc);
    if (buy) return buyNowGo(buy);
    if (mbuy) return addStay(mbuy);
    if (mbuyNow) return buyNowGo(mbuyNow);
  }, true);

  // ---- sticky bottom bar: 滑过产品区后出现；下滑隐藏；停止/上滑弹出 ----
  var bar = document.getElementById('stickyBar');
  var mainCta = document.querySelector('.buy-buttons');
  if (bar && mainCta) {
    var lastY = window.scrollY, stopTimer = null;
    function ctaScrolledPast() {
      // 纯几何判定：CTA 整体已在视口上方（快速甩动/锚点跳转也正确）
      var rect = mainCta.getBoundingClientRect();
      var docTop = rect.top + window.scrollY;
      return window.scrollY > docTop + mainCta.offsetHeight;
    }
    function inView() {
      var r = mainCta.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var up = y < lastY;
      lastY = y;
      if (inView()) { bar.classList.remove('is-visible'); }
      else if (up) { bar.classList.add('is-visible'); }
      else { bar.classList.remove('is-visible'); }
      clearTimeout(stopTimer);
      stopTimer = setTimeout(function () {
        if (ctaScrolledPast() && window.scrollY > 100) bar.classList.add('is-visible');
      }, 160);
    }, { passive: true });
    if (ctaScrolledPast()) bar.classList.add('is-visible');
  }
});
